export function getYouTubeVideoId(url: string): string {
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[7].length === 11 ? match[7] : '';
}

export function loadYouTubeIframeAPI(): Promise<void> {
  const w: any = window as any;
  if (w.YT && w.YT.Player) return Promise.resolve();
  if (w.__ytApiReadyPromise) return w.__ytApiReadyPromise;
  w.__ytApiReadyPromise = new Promise<void>((resolve) => {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag?.parentNode?.insertBefore(tag, firstScriptTag);
    (window as any).onYouTubeIframeAPIReady = () => resolve();
  });
  return w.__ytApiReadyPromise;
}
